(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["About-story-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('nekteck-video-hero')) {
    customElements.define('nekteck-video-hero', class extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('[data-nekteck-video-dialog]');
        this.querySelectorAll('[data-nekteck-video-open]').forEach((button) => {
          button.addEventListener('click', () => this.open());
        });
        this.querySelector('[data-nekteck-video-close]')?.addEventListener('click', () => this.close());
        this.dialog?.addEventListener('click', (event) => {
          if (event.target === this.dialog) this.close();
        });
      }
      open() {
        if (!this.dialog) return;
        this.dialog.showModal();
        this.dialog.querySelector('video')?.play();
      }
      close() {
        if (!this.dialog) return;
        const video = this.dialog.querySelector('video');
        if (video) video.pause();
        this.dialog.close();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bfcm-filtered-deals"] && !Shopify.designMode) return;
  try {
    
  function bfcmFilteredControls(root) {
    const panel = root.querySelector('[data-bfcm-filter-panel]:not([hidden])');
    if (!panel) return;
    const track = panel.querySelector('.bfcm-filtered__track');
    const controls = panel.querySelector('.bfcm-filtered__controls');
    if (!track) return;
    const mobile = window.matchMedia('(max-width: 749px)').matches;
    const pages = [...track.querySelectorAll('.bfcm-filtered__page')];
    if (controls) controls.hidden = mobile ? pages.length <= 1 : track.scrollWidth <= track.clientWidth + 2;
    const counter = panel.querySelector('[data-bfcm-page-count]');
    if (!counter) return;
    counter.hidden = !mobile || pages.length <= 1;
    if (counter.hidden) return;
    const stride = pages[1].offsetLeft - pages[0].offsetLeft;
    const index = stride > 0 ? Math.round(track.scrollLeft / stride) : 0;
    counter.textContent = Math.min(pages.length, Math.max(1, index + 1)) + ' / ' + pages.length;
  }

  function bfcmFilteredInit(root) {
    if (root.dataset.bfcmFilteredReady === 'true') return;
    root.dataset.bfcmFilteredReady = 'true';
    const tabs = [...root.querySelectorAll('[data-bfcm-filter-tab]')];
    if (!tabs.length) return;

    function activate(tab) {
      tabs.forEach((item) => {
        const active = item === tab;
        item.setAttribute('aria-selected', active ? 'true' : 'false');
        item.tabIndex = active ? 0 : -1;
        const panel = root.querySelector('[id="' + item.getAttribute('aria-controls') + '"]');
        if (panel) panel.hidden = !active;
      });
      const panel = root.querySelector('[data-bfcm-filter-panel]:not([hidden])');
      const track = panel && panel.querySelector('.bfcm-filtered__track');
      if (track) track.scrollLeft = 0;
      bfcmFilteredControls(root);
    }

    root.addEventListener('click', (event) => {
      const tab = event.target.closest('[data-bfcm-filter-tab]');
      if (tab && root.contains(tab)) {
        activate(tab);
        return;
      }
      const arrow = event.target.closest('[data-bfcm-filter-scroll]');
      if (!arrow || !root.contains(arrow)) return;
      const track = arrow.closest('[data-bfcm-filter-panel]').querySelector('.bfcm-filtered__track');
      const direction = arrow.dataset.bfcmFilterScroll === 'next' ? 1 : -1;
      if (window.matchMedia('(max-width: 749px)').matches) {
        const pages = [...track.querySelectorAll('.bfcm-filtered__page')];
        if (pages.length <= 1) return;
        const stride = pages[1].offsetLeft - pages[0].offsetLeft;
        const current = stride > 0 ? Math.round(track.scrollLeft / stride) : 0;
        const next = Math.min(pages.length - 1, Math.max(0, current + direction));
        track.scrollTo({ left: next * stride, behavior: 'auto' });
        bfcmFilteredControls(root);
      } else {
        track.scrollBy({ left: direction * Math.min(480, track.clientWidth * .85), behavior: 'smooth' });
      }
    });

    root.addEventListener('keydown', (event) => {
      const tab = event.target.closest('[data-bfcm-filter-tab]');
      if (!tab || !root.contains(tab)) return;
      const index = tabs.indexOf(tab);
      let next = index;
      if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
      else if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
      else if (event.key === 'Home') next = 0;
      else if (event.key === 'End') next = tabs.length - 1;
      else return;
      event.preventDefault();
      tabs[next].focus();
      activate(tabs[next]);
    });

    root.querySelectorAll('.bfcm-filtered__track').forEach((track) => {
      track.addEventListener('scroll', () => bfcmFilteredControls(root), { passive: true });
    });

    activate(tabs[0]);
  }

  function bfcmFilteredInitAll(scope) {
    if (scope.matches && scope.matches('[data-bfcm-filtered]')) bfcmFilteredInit(scope);
    scope.querySelectorAll('[data-bfcm-filtered]').forEach(bfcmFilteredInit);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => bfcmFilteredInitAll(document), { once: true });
  else bfcmFilteredInitAll(document);
  window.addEventListener('resize', () => document.querySelectorAll('[data-bfcm-filtered]').forEach(bfcmFilteredControls));
  document.addEventListener('shopify:section:load', (event) => bfcmFilteredInitAll(event.target));
  document.addEventListener('shopify:block:select', (event) => {
    const panel = event.target.closest('[data-bfcm-filter-panel]');
    const root = panel && panel.closest('[data-bfcm-filtered]');
    if (!root) return;
    const tab = [...root.querySelectorAll('[data-bfcm-filter-tab]')].find((item) => item.getAttribute('aria-controls') === panel.id);
    if (tab) tab.click();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bfcm-gifts"] && !Shopify.designMode) return;
  try {
    
  function bfcmRenderGifts(section, total) {
    const cards = [...section.querySelectorAll('[data-gift-threshold]')];
    const values = cards.map(card => Number(card.dataset.giftThreshold)).sort((a, b) => a - b);
    const unlocked = values.filter(value => total >= value).at(-1) || 0;
    cards.forEach(card => {
      const active = Number(card.dataset.giftThreshold) === unlocked;
      card.classList.toggle('bfcm-gifts__card--unlocked', active);
      card.querySelector('[data-gift-status]').textContent = active ? section.dataset.unlocked : section.dataset.preview;
    });
  }
  async function bfcmRefreshGifts(section) {
    try {
      const response = await fetch(section.dataset.cartUrl, { credentials: 'same-origin', cache: 'no-store' });
      if (!response.ok) return;
      const cart = await response.json();
      bfcmRenderGifts(section, Number(cart.total_price) || 0);
    } catch (_) {}
  }
  function bfcmRefreshAllGifts() {
    document.querySelectorAll('[data-bfcm-gifts]').forEach(bfcmRefreshGifts);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bfcmRefreshAllGifts, { once: true });
  else bfcmRefreshAllGifts();
  document.addEventListener('cart:updated', bfcmRefreshAllGifts);
  document.addEventListener('cart:change', bfcmRefreshAllGifts);
  document.addEventListener('shopify:section:load', bfcmRefreshAllGifts);
  document.addEventListener('visibilitychange', () => { if (!document.hidden) bfcmRefreshAllGifts(); });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bfcm-tiered-deals"] && !Shopify.designMode) return;
  try {
    
  const bfcmUpdateDealControls = () => {
    document.querySelectorAll('.bfcm-deals__tier').forEach((tier) => {
      const track = tier.querySelector('.bfcm-deals__track');
      const controls = tier.querySelector('.bfcm-deals__controls');
      if (!track || !controls) return;
      controls.hidden = track.scrollWidth <= track.clientWidth + 2;
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bfcmUpdateDealControls, { once: true });
  } else {
    bfcmUpdateDealControls();
  }
  window.addEventListener('resize', bfcmUpdateDealControls);
  document.addEventListener('shopify:section:load', bfcmUpdateDealControls);

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-bfcm-scroll]');
    if (!button) return;
    const tier = button.closest('.bfcm-deals__tier');
    const track = tier && tier.querySelector('.bfcm-deals__track');
    if (!track) return;
    const direction = button.dataset.bfcmScroll === 'next' ? 1 : -1;
    track.scrollBy({ left: direction * Math.min(540, track.clientWidth * .85), behavior: 'smooth' });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-blog-new"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const prepareSliders = (root) => {
      root.querySelectorAll('.apple-blog--mobile-slider .apple-blog__grid').forEach((slider) => {
        if (slider.dataset.appleBlogSliderReady === 'true') return;
        slider.dataset.appleBlogSliderReady = 'true';

        const section = slider.closest('.apple-blog');
        const cards = Array.from(slider.querySelectorAll('.apple-blog-card'));
        const dots = Array.from(section.querySelectorAll('[data-apple-blog-dot]'));

        const getStep = () => {
          const card = cards[0];
          const gap = parseFloat(getComputedStyle(slider).columnGap) || 0;
          return card ? card.getBoundingClientRect().width + gap : 0;
        };

        const updatePagination = () => {
          const step = getStep();
          if (step === 0 || dots.length === 0) return;
          const activeIndex = Math.max(0, Math.min(dots.length - 1, Math.round(slider.scrollLeft / step)));
          dots.forEach((dot, index) => {
            const isActive = index === activeIndex;
            dot.classList.toggle('is-active', isActive);
            dot.setAttribute('aria-current', isActive ? 'true' : 'false');
          });
        };

        let scrollFrame = 0;
        slider.addEventListener('scroll', () => {
          if (scrollFrame) return;
          scrollFrame = requestAnimationFrame(() => {
            updatePagination();
            scrollFrame = 0;
          });
        }, { passive: true });

        dots.forEach((dot) => {
          dot.addEventListener('click', () => {
            const step = getStep();
            const index = Number(dot.dataset.appleBlogDot);
            slider.scrollTo({ left: index * step, behavior: 'smooth' });
          });
        });

        updatePagination();
      });
    };

    prepareSliders(document);
    document.addEventListener('shopify:section:load', (event) => prepareSliders(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-card-scroller"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('apple-card-scroller')) {
    customElements.define(
      'apple-card-scroller',
      class AppleCardScroller extends HTMLElement {
        connectedCallback() {
          this.viewport = this.querySelector('[data-acs-viewport]');
          this.previousButton = this.querySelector('[data-acs-previous]');
          this.nextButton = this.querySelector('[data-acs-next]');

          if (!this.viewport) return;

          this.handlePrevious = () => this.scrollByCard(-1);
          this.handleNext = () => this.scrollByCard(1);
          this.handleScroll = () => this.updateButtons();

          this.previousButton?.addEventListener('click', this.handlePrevious);
          this.nextButton?.addEventListener('click', this.handleNext);
          this.viewport.addEventListener('scroll', this.handleScroll, { passive: true });

          this.resizeObserver = new ResizeObserver(() => this.updateButtons());
          this.resizeObserver.observe(this.viewport);
          this.updateButtons();
        }

        disconnectedCallback() {
          this.previousButton?.removeEventListener('click', this.handlePrevious);
          this.nextButton?.removeEventListener('click', this.handleNext);
          this.viewport?.removeEventListener('scroll', this.handleScroll);
          this.resizeObserver?.disconnect();
        }

        scrollByCard(direction) {
          const firstCard = this.querySelector('.acs__item');
          if (!firstCard) return;

          const track = this.querySelector('.acs__track');
          const gap = Number.parseFloat(getComputedStyle(track).gap) || 0;
          const distance = firstCard.getBoundingClientRect().width + gap;

          this.viewport.scrollBy({ left: direction * distance, behavior: 'smooth' });
        }

        updateButtons() {
          if (!this.previousButton || !this.nextButton) return;

          const maximum = this.viewport.scrollWidth - this.viewport.clientWidth;
          const position = Math.abs(this.viewport.scrollLeft);

          this.previousButton.disabled = position <= 2;
          this.nextButton.disabled = position >= maximum - 2;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-customer-spotlight-pro"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const setup = (root) => {
      if (!root || root.dataset.spotlightReady === 'true') return;

      const track = root.querySelector('[data-spotlight-track]');
      const cards = Array.from(root.querySelectorAll('[data-spotlight-card]'));
      const previous = root.querySelector('[data-spotlight-prev]');
      const next = root.querySelector('[data-spotlight-next]');
      const dots = Array.from(root.querySelectorAll('[data-spotlight-dot]'));

      if (!track || cards.length === 0) return;

      root.dataset.spotlightReady = 'true';
      let frame;

      const cardStep = () => {
        const firstCard = cards[0];
        if (!firstCard) return track.clientWidth;

        const styles = window.getComputedStyle(track);
        const gap = Number.parseFloat(styles.columnGap || styles.gap || '0');
        return firstCard.getBoundingClientRect().width + gap;
      };

      const nearestIndex = () => {
        const trackLeft = track.getBoundingClientRect().left;
        let selected = 0;
        let distance = Infinity;

        cards.forEach((card, index) => {
          const currentDistance = Math.abs(card.getBoundingClientRect().left - trackLeft);
          if (currentDistance < distance) {
            distance = currentDistance;
            selected = index;
          }
        });

        return selected;
      };

      const update = () => {
        if (track.clientWidth === 0) return;

        const index = nearestIndex();
        const maximum = Math.max(0, track.scrollWidth - track.clientWidth);

        if (previous) previous.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft >= maximum - 2;

        dots.forEach((dot, dotIndex) => {
          const active = dotIndex === index;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-current', active ? 'true' : 'false');
        });
      };

      const scrollToCard = (index) => {
        const target = cards[Math.max(0, Math.min(cards.length - 1, index))];
        if (!target) return;
        track.scrollTo({ left: target.offsetLeft - cards[0].offsetLeft, behavior: 'smooth' });
      };

      previous?.addEventListener('click', () => {
        track.scrollBy({ left: -cardStep(), behavior: 'smooth' });
      });

      next?.addEventListener('click', () => {
        track.scrollBy({ left: cardStep(), behavior: 'smooth' });
      });

      dots.forEach((dot) => {
        dot.addEventListener('click', () => scrollToCard(Number(dot.dataset.spotlightDot)));
      });

      track.addEventListener('scroll', () => {
        window.cancelAnimationFrame(frame);
        frame = window.requestAnimationFrame(update);
      }, { passive: true });

      new ResizeObserver(update).observe(track);
      window.requestAnimationFrame(() => window.requestAnimationFrame(update));
      window.addEventListener('load', update, { once: true });
    };

    const setupAll = (scope = document) => {
      scope.querySelectorAll('[data-spotlight]').forEach(setup);
    };

    setupAll();
    document.addEventListener('shopify:section:load', (event) => setupAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-featured-product-cards-new"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('featured-product-cards-slider')) {
    class FeaturedProductCardsSlider extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        this.previousButtons = Array.from(this.querySelectorAll('[data-previous]'));
        this.nextButtons = Array.from(this.querySelectorAll('[data-next]'));
        this.controls = this.querySelector('[data-controls]');
        this.mobileControls = this.querySelector('[data-mobile-controls]');
        this.dots = Array.from(this.querySelectorAll('[data-dot]'));

        if (!this.track || this.slides.length === 0) return;

        this.frame = null;
        this.handleScroll = this.handleScroll.bind(this);
        this.handleResize = this.handleResize.bind(this);

        this.previousButtons.forEach((button) => {
          button.addEventListener('click', () => this.move(-1));
        });

        this.nextButtons.forEach((button) => {
          button.addEventListener('click', () => this.move(1));
        });

        this.dots.forEach((dot, index) => {
          dot.addEventListener('click', () => this.goTo(index));
        });

        this.track.addEventListener('scroll', this.handleScroll, { passive: true });
        window.addEventListener('resize', this.handleResize, { passive: true });
        this.update();
      }

      disconnectedCallback() {
        if (this.track) this.track.removeEventListener('scroll', this.handleScroll);
        window.removeEventListener('resize', this.handleResize);
        if (this.frame) cancelAnimationFrame(this.frame);
      }

      handleScroll() {
        if (this.frame) cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.update());
      }

      handleResize() {
        this.update();
      }

      closestIndex() {
        let activeIndex = 0;
        let closestDistance = Infinity;
        const trackLeft = this.track.getBoundingClientRect().left;

        this.slides.forEach((slide, index) => {
          const slideLeft = slide.getBoundingClientRect().left - trackLeft + this.track.scrollLeft;
          const distance = Math.abs(slideLeft - this.track.scrollLeft);
          if (distance < closestDistance) {
            closestDistance = distance;
            activeIndex = index;
          }
        });

        return activeIndex;
      }

      move(direction) {
        const currentIndex = this.closestIndex();
        const nextIndex = Math.max(0, Math.min(this.slides.length - 1, currentIndex + direction));
        this.goTo(nextIndex);
      }

      goTo(index) {
        const slide = this.slides[index];
        if (!slide) return;
        const trackLeft = this.track.getBoundingClientRect().left;
        const slideLeft = slide.getBoundingClientRect().left - trackLeft + this.track.scrollLeft;
        this.track.scrollTo({ left: slideLeft, behavior: 'smooth' });
      }

      update() {
        const activeIndex = this.closestIndex();
        const maxScroll = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
        const hasOverflow = maxScroll > 2;

        if (this.controls) this.controls.hidden = !hasOverflow;
        if (this.mobileControls) this.mobileControls.hidden = !hasOverflow;
        this.previousButtons.forEach((button) => {
          button.disabled = this.track.scrollLeft <= 2;
        });
        this.nextButtons.forEach((button) => {
          button.disabled = this.track.scrollLeft >= maxScroll - 2;
        });

        this.dots.forEach((dot, index) => {
          const isActive = index === activeIndex;
          dot.classList.toggle('is-active', isActive);
          dot.setAttribute('aria-current', isActive ? 'true' : 'false');
        });
      }
    }

    customElements.define('featured-product-cards-slider', FeaturedProductCardsSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-press-endorsements-new"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (root) => {
      root.querySelectorAll('.press-endorsements-new').forEach((section) => {
        if (section.dataset.pressMobileReady === 'true') return;
        const slider = section.querySelector('.press-endorsements-new__rows');
        const items = Array.from(section.querySelectorAll('.press-endorsements-new__item'));
        const previous = section.querySelector('[data-press-prev]');
        const next = section.querySelector('[data-press-next]');
        const count = section.querySelector('[data-press-count]');
        const progress = section.querySelector('[data-press-progress]');
        if (!slider || items.length < 2 || !previous || !next || !count || !progress) return;
        section.dataset.pressMobileReady = 'true';

        const positions = () => items.map((item) => item.offsetLeft - items[0].offsetLeft);
        const activeIndex = () => {
          const offsets = positions();
          return offsets.reduce((best, offset, index) => Math.abs(offset - slider.scrollLeft) < Math.abs(offsets[best] - slider.scrollLeft) ? index : best, 0);
        };
        const update = () => {
          const index = activeIndex();
          count.textContent = `${String(index + 1).padStart(2, '0')} / ${String(items.length).padStart(2, '0')}`;
          progress.style.width = `${((index + 1) / items.length) * 100}%`;
          previous.disabled = index === 0;
          next.disabled = index === items.length - 1;
        };
        const goTo = (index) => {
          const target = Math.max(0, Math.min(items.length - 1, index));
          slider.scrollTo({ left: positions()[target], behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        };

        previous.addEventListener('click', () => goTo(activeIndex() - 1));
        next.addEventListener('click', () => goTo(activeIndex() + 1));
        let frame = 0;
        slider.addEventListener('scroll', () => {
          if (frame) return;
          frame = requestAnimationFrame(() => { update(); frame = 0; });
        }, { passive: true });
        window.addEventListener('resize', update, { passive: true });
        update();
      });
    };
    initialize(document);
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-prime-flash-sale"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('flash-sale-slider')) {
    customElements.define(
      'flash-sale-slider',
      class FlashSaleSlider extends HTMLElement {
        connectedCallback() {
          this.viewport = this.querySelector('[data-flash-viewport]');
          this.track = this.querySelector('[data-flash-track]');
          this.cards = Array.from(this.querySelectorAll('[data-flash-card]'));
          this.previousButton = this.querySelector('[data-flash-previous]');
          this.nextButton = this.querySelector('[data-flash-next]');
          this.dots = Array.from(this.querySelectorAll('[data-flash-dot]'));

          if (!this.viewport || !this.track || this.cards.length === 0) return;

          this.handlePrevious = () => this.scrollByCard(-1);
          this.handleNext = () => this.scrollByCard(1);
          this.handleScroll = () => this.updateNavigation();
          this.handleBlockSelect = (event) => this.revealBlock(event);
          this.handleDotClick = (event) => this.scrollToCard(Number(event.currentTarget.dataset.flashDot));

          this.previousButton?.addEventListener('click', this.handlePrevious);
          this.nextButton?.addEventListener('click', this.handleNext);
          this.viewport.addEventListener('scroll', this.handleScroll, { passive: true });
          this.addEventListener('shopify:block:select', this.handleBlockSelect);
          this.dots.forEach((dot) => dot.addEventListener('click', this.handleDotClick));

          this.resizeObserver = new ResizeObserver(() => this.updateNavigation());
          this.resizeObserver.observe(this.viewport);
          this.updateNavigation();
        }

        disconnectedCallback() {
          this.previousButton?.removeEventListener('click', this.handlePrevious);
          this.nextButton?.removeEventListener('click', this.handleNext);
          this.viewport?.removeEventListener('scroll', this.handleScroll);
          this.removeEventListener('shopify:block:select', this.handleBlockSelect);
          this.dots?.forEach((dot) => dot.removeEventListener('click', this.handleDotClick));
          this.resizeObserver?.disconnect();
        }

        getStep() {
          const firstCard = this.cards[0];
          if (!firstCard) return 0;
          const gap = Number.parseFloat(getComputedStyle(this.track).columnGap) || 0;
          return firstCard.getBoundingClientRect().width + gap;
        }

        getBehavior() {
          return window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
        }

        scrollByCard(direction) {
          this.viewport.scrollBy({ left: direction * this.getStep(), behavior: this.getBehavior() });
        }

        scrollToCard(index) {
          const card = this.cards[index];
          if (!card) return;
          const viewportRect = this.viewport.getBoundingClientRect();
          const cardRect = card.getBoundingClientRect();
          const viewportPadding = Number.parseFloat(getComputedStyle(this.viewport).paddingLeft) || 0;
          const targetPosition = this.viewport.scrollLeft + cardRect.left - viewportRect.left - viewportPadding;
          this.viewport.scrollTo({ left: targetPosition, behavior: this.getBehavior() });
        }

        revealBlock(event) {
          const card = event.target.closest('[data-flash-card]');
          if (!card) return;
          card.scrollIntoView({ behavior: this.getBehavior(), block: 'nearest', inline: 'center' });
        }

        updateNavigation() {
          const maximum = Math.max(0, this.viewport.scrollWidth - this.viewport.clientWidth);
          const position = Math.abs(this.viewport.scrollLeft);
          const viewportRect = this.viewport.getBoundingClientRect();
          const viewportPadding = Number.parseFloat(getComputedStyle(this.viewport).paddingLeft) || 0;
          const viewportLeft = viewportRect.left + viewportPadding;
          let activeIndex = 0;
          let closestDistance = Number.POSITIVE_INFINITY;

          this.cards.forEach((card, index) => {
            const distance = Math.abs(card.getBoundingClientRect().left - viewportLeft);
            if (distance < closestDistance) {
              closestDistance = distance;
              activeIndex = index;
            }
          });

          if (this.previousButton) this.previousButton.disabled = position <= 2;
          if (this.nextButton) this.nextButton.disabled = position >= maximum - 2;

          this.dots.forEach((dot, index) => {
            const active = index === activeIndex;
            dot.classList.toggle('is-active', active);
            if (active) {
              dot.setAttribute('aria-current', 'true');
            } else {
              dot.removeAttribute('aria-current');
            }
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
